module.exports = __webpack_public_path__ + "static/media/No Record.571765d1.png";